module.exports = __webpack_public_path__ + "img/list.75816faa.svg";